import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { Toaster } from '@CommonComponents/toast'
import formatMessage from 'format-message'
import { StateProvider } from './state'
import DrawerHeader from '../DrawerHeader'
import { SearchForm } from './SearchForm'
import { HighlightsContainer } from './HighlightsContainer'

export const DrawerNotebook = ({ coursenum }) => {
  const containerRef = useRef(null)

  useEffect(() => {
    const input = containerRef.current?.querySelector('input[type="search"]')
    if (input) input.focus()
  }, [])

  const initialState = {
    highlights: [],
    filters: { search: '', chapters: [], tags: [], colors: [] },
    colors: [],
    chapters: [],
    tags: [],
    coursenum: coursenum,
    message: '',
    deleteModalOpen: false,
    toDeleteIds: [],
    editingIDs: [],
    hasMore: false,
    highlightTotal: 0,
  }

  return (
    <StateProvider initialState={initialState} reducer={reducer}>
      <div className="d-flex flex-column h-100" ref={containerRef}>
        <Toaster />
        <DrawerHeader title={formatMessage('Notebook')} />
        <div className="flex-grow-1 overflow-y-auto" style={{ minHeight: 0 }}>
          <SearchForm />
          <HighlightsContainer />
        </div>
      </div>
    </StateProvider>
  )
}

DrawerNotebook.propTypes = {
  coursenum: PropTypes.string,
}

const reducer = (state, action) => {
  switch (action.type) {
    case 'updatePageID':
      return {
        ...state,
        pageId: action.payload,
      }
    case 'updateChapters':
      return {
        ...state,
        chapters: action.payload,
      }
    case 'updateFilters':
      return {
        ...state,
        filters: action.payload,
      }
    case 'updateColors':
      return {
        ...state,
        colors: action.payload,
      }
    case 'updateHighlights':
      return {
        ...state,
        highlights: action.payload,
      }
    case 'appendHighlights':
      return {
        ...state,
        highlights: [...state.highlights, ...action.payload],
      }
    case 'updateHasMore':
      return {
        ...state,
        hasMore: action.payload,
      }
    case 'updateHighlightTotal':
      return {
        ...state,
        highlightTotal: action.payload,
      }
    case 'updatePageNum':
      return {
        ...state,
        page: action.payload,
      }
    case 'updateTags':
      return {
        ...state,
        tags: action.payload,
      }
    case 'updateMessage':
      return {
        ...state,
        message: action.payload,
      }
    case 'updateEditingIDs':
      return {
        ...state,
        editingIDs: action.payload,
      }
    case 'updateToDeleteIds':
      return {
        ...state,
        toDeleteIds: action.payload,
      }
    default:
      return state
  }
}
